import { useState } from "react";
import * as yup from 'yup';

const useHandleForm = (data, createCallback, modifyCallback, invalidDataCallback) => {

  const isCreate = !Boolean(data);

  const createInitialData = () => {

    const getInitialFieldData = (fieldName) => {
      if (fieldName === "notNull") {
        return isCreate ? false : data[fieldName];
      }

      return isCreate ? "" : data[fieldName];
    }

    const fieldNames = [
      "fieldCode",
      "name",
      "type",
      "subType",
      "size",
      "notNull",
      "default",
    ];

    return fieldNames.reduce((initialData, fieldName) => {
      return ({
        ...initialData,
        [fieldName]: getInitialFieldData(fieldName)
      })
    }, {});
  }

  const [formData, setFormData] = useState(createInitialData());

  const dataIsValid = async () => {
    const regex = /^U_[a-z0-9_]+$/;

    const schema = yup.object().shape({
      "fieldCode": yup.string().max(18).matches(regex).required(),
      "name": yup.string().max(30).required(),
      "type": yup.string().max(30).required(),
      "subType": yup.string().max(30).when('type', {
        is: (type) => type === "B",
        then: yup.string().required()
      }),
      "size": yup.number().required().when('type', {
        is: (type) => type === "A",
        then: yup.number().min(1).max(254).required(),
      }).when('type', {
        is: (type) => type === "N",
        then: yup.number().min(1).max(16).required(),
      }),
      "notNull": yup.boolean(),
      "default": yup.string().max(30),
    });

    return await schema.validate(formData, { abortEarly: false })
      .then((castData) => castData)
      .catch(err => {
        if (err instanceof yup.ValidationError) {
          err.inner.forEach(error => {
            console.log(error.message);
          });
          return false;
        }
      });
  }

  const submit = async () => {
    if (await dataIsValid()) {
      let dataToSend = {
        ...formData,
      };

      if (isCreate) {
        createCallback(dataToSend);
      } else {
        modifyCallback(dataToSend);
      }

      return true;
    } else {
      invalidDataCallback();
      return false;
    }
  }

  const setFormValue = (value, fieldName) => {
    if (fieldName === "type") {
      switch (value) {
        default:
        case "A":
          setFormData({
            ...formData,
            [fieldName]: value,
            "subType": "",
            "size": ""
          });
          break;
        case "N":
          setFormData({
            ...formData,
            [fieldName]: value,
            "subType": "",
            "size": "",
          });
          break;
        case "D":
          setFormData({
            ...formData,
            [fieldName]: value,
            "subType": "",
            "size": 8,
          });
          break;
        case "B":
          setFormData({
            ...formData,
            [fieldName]: value,
            "size": 16,
          });
          break;
        case "M":
          setFormData({
            ...formData,
            [fieldName]: value,
            "size": 8,
            "default": "",
          });
          break;
      }

      return;
    }

    if (fieldName === "subType" && formData.type === "N" && value === "T") {
      setFormData({
        ...formData,
        [fieldName]: value,
        "size": "4"
      });
      
      return;
    }

    setFormData({
      ...formData,
      [fieldName]: value,
    });
  }

  return { formData, setFormValue, submit, isCreate };
}

export default useHandleForm;
